// @flow
import {
	WebComponent,
} from 'fg-frontend';
import tippy from 'tippy.js';

export default class BtnVariant extends WebComponent {
	didMount() {
		const {
			img,
			imgZoom,
			title,
			tooltip,
		} = this.props;

		const btnLabel = this.element.querySelector('label');
		const touchDevice =  'ontouchstart' in window;

		if (!touchDevice) {
			btnLabel.style.backgroundImage = 'url(' + img + ')';
		}
		else {
			btnLabel.classList.add('touch');
			if (!!imgZoom) {
				btnLabel.style.backgroundImage = 'url(' + imgZoom + ')';
			}
		}

		if (!!tooltip) {
			const tip = tippy(btnLabel, {
				animation: 'shift-toward',
				arrow: true,
				html: tooltip,
				theme: 'esp-variant',
				onShow() {
					const content = this.querySelector('.tippy-content');
					content.innerHTML = `<span class="tippy-content__title">${title}</span><img src="${imgZoom}" width="220" height="220">`;
				},
				onHidden() {
					const content = this.querySelector('.tippy-content')
					content.innerHTML = '';
				},
				// prevent tooltip from displaying over button
				popperOptions: {
					modifiers: {
						preventOverflow: {
							enabled: false,
						},
						hide: {
							enabled: false,
						}
					}
				}
			});
		}
		else {
			const defaultTip = tippy(btnLabel, {
				arrow: true,
				theme: 'esp-variant',
			});
		}

		tippy.browser.onUserInputChange = type => {
			const method = type === 'touch' ? 'enable' : 'disable'
			for (const tooltip of tip.tooltips) {
				tooltip[method]();
			}
		}

	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/components/BtnVariant.js